import { getColorValue, viewupTheme } from '@viewup/ui';

export const mainSwiperPaginationCss = {
  '& .swiper-pagination-bullet': {
    backgroundColor: getColorValue('bg.dimmer.60', viewupTheme),
    borderRadius: 16,
    height: 8,
    margin: '0 2px !important',
    transition: 'width .25s ease-in-out',
    width: 8,
  },
  '& .swiper-pagination-bullet-active': {
    backgroundColor: getColorValue('bg.dimmer.40', viewupTheme),
    transition: 'width .25s ease-in-out',
    width: 16,
  },
} as const;
